<script setup lang="ts">
  import {computed} from 'vue';
  import useCpBem from '~/composables/useCpBem';
  import CpNavMenuPromo from '~/components/cp/CpNavMenu/CpNavMenuPromo/CpNavMenuPromo.vue';
  import {useCategoriesMenuStore} from '~/stores';

  const categoriesStore = useCategoriesMenuStore();
  const specialLinks = computed(() => {
      return categoriesStore.categories?.filter((cat) => !cat.hasSubCategories);
  });
  const {b} = useCpBem('cp-nav-menu-special-links');
</script>

<template>
    <div :class="b" data-testid="special-links">
        <CpNavMenuPromo v-for="sl in specialLinks"
            :key="sl.id"
            :image="sl.image"
            :name="sl.title"
            :link="sl.link"
        />
    </div>
</template>

<style scoped lang="scss">
  .cp-nav-menu-special-links {
    display: flex;
    justify-content: center;
    padding: $cp-gutter;
    gap: $cp-gutter;
    border-bottom: $cp-border-standard;
  }
</style>
